export default __webpack_public_path__ + "static/media/online-pk-7-banner-graphics.72189148.svg";